import {MdPlaylistAdd} from "react-icons/md";


const AddToActiveButton = () => {
    return <MdPlaylistAdd/>
}
export default AddToActiveButton